import { jsx } from "react/jsx-runtime";
import { HTMLSelect } from "@blueprintjs/core";
import React from "react";
import classNames from "classnames";
const TgHTMLSelect = ({ disabled, ...rest }) => {
  if (disabled) {
    const opt = rest.options.find((o) => o.value === rest.value);
    return /* @__PURE__ */ jsx("div", { ...rest, className: classNames("bp3-html-select", rest.className), children: opt.label });
  }
  return /* @__PURE__ */ jsx(HTMLSelect, { ...rest });
};
export default TgHTMLSelect;
